import Box from "@mui/material/Box";
import { plusIcon } from "../../../../common/vector";

interface PassengerAddButtonProps {
  onClick: () => void;
}

export default function PassengerAddButton({ onClick }: PassengerAddButtonProps) {
  return (
    <Box onClick={onClick} sx={{ cursor: "pointer", width: "24px" }}>
      <img src={plusIcon?.default} alt="close-dark" height={24} width={24} />
    </Box>
  );
}
